import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from './WallPaneling.module.scss';
import defaultImage from '../../../assets/default.png'

const WallPaneling = (props: any) => {
  const dispatch = useDispatch();
  const [materialDetails, setMaterialDetails] = useState([]);
  const pageDetails = useSelector((state: any) => state.wizard.pageDetails);


  // Function to split data into chunks of 4
  const splitDataIntoChunks = (data, chunkSize) => {
    const chunkedArray = [];
    for (let i = 0; i < data.length; i += chunkSize) {
      chunkedArray.push(data.slice(i, i + chunkSize));
    }
    return chunkedArray;
  };

  useEffect(() => {
    const columns = splitDataIntoChunks(pageDetails?.wallCladdingDetails, 3);
    setMaterialDetails(columns);
  }, [pageDetails])

  return (
    <section className={style.wall_paneling_container}>
      <h2 className="section_heading">{pageDetails?.name}</h2>
      <div className={style.paneling_details_tabs}>
        <div className={style.paneling_image_columns}>
          <img crossOrigin="anonymous"  src={pageDetails?.images ? `${pageDetails?.images?.[0]?.imageUrl}?ver=${new Date().getTime()}` : defaultImage} alt="" className="image-view" />
        </div>
        <div className={style.paneling_table_tabs}>
          <div className={style.paneling_item_container}>
            <h2 className="sub_tab_heading">Material Info</h2>
            <div className={style.paneling_item_details} style={{ display: 'grid', gridTemplateColumns: `repeat(${materialDetails?.length}, 1fr)` }}>
              {
                materialDetails?.length ? materialDetails?.map((e, i) => (
                  <div>
                    <div className={style.paneling_items_heading}>
                      <h4>Annotation</h4>
                      <h4>Name</h4>
                      <h4>Back panel</h4>
                    </div>
                    {
                      e?.map((v) => (
                        <div className={style.paneling_items_list}>
                          <p>{v?.annotation?.code}</p>
                          <p>{v?.name}</p>
                          <p>{v?.annotation?.hasBackPanel ? 'Yes' : 'No'}</p>
                        </div>
                      ))
                    }
                  </div>
                )) : ''
              }
            </div>
          </div>
          <div className={style.paneling_item_container}>
            <h2 className="sub_tab_heading">Legend</h2>
            <div className={style.legend_item_details}>
              <p>Open Panel Edge</p>
              <p className={style.panel_edgeLine}></p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WallPaneling;